export const modalOutline = {
  overflowY: 'auto',
  '> div:first-of-type :focus': {
    outline: 'none !important',
    outlineOffset: '0px !important',
  },
};

const modalContainer = {
  maxHeight: '100%',
  margin: '0 auto',
  padding: 0,
};

export const modalContainerExtraSmall = {
  ...modalContainer,
  maxWidth: 300,
};

export const modalContainerSmall = {
  ...modalContainer,
  maxWidth: 460,
};

export const modalContainerMedium = {
  ...modalContainer,
  maxWidth: 620,
};

export const modalContainerLarge = {
  ...modalContainer,
  maxWidth: 780,
};

export const modalContainerExtraLarge = {
  ...modalContainer,
  maxWidth: 940,
};
